import request from '@/utils/request'
let preBase = 'mixApi'

// 鹭愿卡-登录接口
export const luyuanLogin = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/login`,
    method: 'post',
    data
  })
}
// 鹭愿卡-新客礼校验接口
export const luyuanNewCustomerCheck = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/check`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-新客礼领取接口
export const luyuanNewCustomerReceive = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/receive`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-新客礼领取实物详情接口
export const luyuanNewCustomerGiftPhysicalDetail = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/queryPhysicalGoodsDetail`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-新客礼领取虚拟详情接口
export const luyuanNewCustomerGiftVirtualDetail = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/queryCouponWareDetail`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-新客礼查询商品配置
export const luyuanNewCustomerQueryConfig = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/queryConfig`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-新客礼查询活动详情接口
export const luyuanNewCustomerQueryActivityDetail = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/getActivityDetail`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-新客礼查询领取记录接口
export const luyuanNewCustomerGetRecordPages = (data) => {
  return request({
    url: `${preBase}/xibNewCustomerGiftLuyuan/queryReceiveRecordDetail`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}

// 鹭愿卡-提升礼

// 鹭愿卡-提升礼查活动详情
export const luyuanGetLuyuanActivityDetail = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/getActivityDetail`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-提升礼-查询权益信息
export const luyuanXibEnhanceQueryRights = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/queryRights`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-提升礼-获取省市区
export const luyuanXibRegionList = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/listRegion`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-提升礼-领取
export const luyuanXibEnhanceReceive = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/receive`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-提升礼-实物的领取详情
export const luyuanXibEnhanceUpdateNotify = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/getDetailsById`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-提升礼-领取记录
export const luyuanGetRecordPages = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/getRecordPages`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
// 鹭愿卡-提升礼-报名
export const luyuanSignUp = (data) => {
  return request({
    url: `${preBase}/xibEgretEnhance/signUp`,
    method: 'post',
    token: sessionStorage.getItem('luyuanToken'),
    data
  })
}
